<template>
  <div class="join-component" :class="[{ 'column': 'col-block', 'row': 'row-block' }[type]]" :style="{ gap: gap }">
    <template v-for="(n, i) in Object.keys($slots).filter(n => !['separator'].includes(n))">
      <template v-if="i">
        <slot v-if="$slots['separator']" :name="'separator'"></slot>
        <hr v-else :key="'separator-' + i">
      </template>
      <slot :name="n"></slot>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: () => 'column'
    },
    gap: {
      type: String,
      default: () => '0px'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/tool/joinComponent.vue